import { Button, Modal } from 'react-bootstrap';

export interface IChangedDetail {
    label: string,
    original: string,
    updated: string
}

interface IProps {
    show: boolean,
    changes: IChangedDetail[],
    onConfirm: () => void,
    onCancel: () => void
}

const display = (value: string) => value != '' ? value : '(blank)';

export default function ConfirmChanges({ show, changes, onConfirm, onCancel }: IProps) {
    return (
        <Modal show={show} backdrop='static' onHide={onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Microsite Details Changed</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {changes.length == 0 ? (
                    <div>No details have been changed.</div>
                ) : (
                    <>
                        <div>The below details have been changed:</div>
                        <ul>
                            {changes.map(x => (
                                <li key={'original-' + x.label}><strong>{x.label}:</strong> {display(x.original)}</li>
                            ))}
                        </ul>

                        <div>The updated details are:</div>
                        <ul>
                            {changes.map(x => (
                                <li key={'updated-' + x.label}><strong>{x.label}:</strong> {display(x.updated)}</li>
                            ))}
                        </ul>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={onConfirm}>Save Changes</Button>
                <Button onClick={onCancel}>Cancel Changes</Button>
            </Modal.Footer>
        </Modal>
    );
}
